import type { FilmMetadata } from "../types/media";
import type { FilmAction } from "./actions";

export interface FilmState {
  selectedFilm: FilmMetadata | "";
  favoriteFilms: Record<string, FilmMetadata[]>;
  expectedFilms: Record<string, FilmMetadata[]>;
}
const film: FilmState = {
  selectedFilm: "",
  favoriteFilms: {},
  expectedFilms: {}
};

export const filmReducer = (state: FilmState = film, action: FilmAction): FilmState => {
  switch (action.type) {
    case "setSelectedFilm": {
      return {
        ...state,
        selectedFilm: action.payload
      };
    }
    case "setFavoriteFilm": {
      const favoriteFilmsHasCurrentUser =
        state.favoriteFilms[action.payload.user.email];
      const filmOnList = state.favoriteFilms[action.payload.user.email]?.some(
        (film) => film.id === action.payload.favoriteFilm.id
      );

      if (!filmOnList) {
        if (!favoriteFilmsHasCurrentUser) {
          state.favoriteFilms[action.payload.user.email] = [];
        }
        return {
          ...state,
          favoriteFilms: {
            ...state.favoriteFilms,
            [action.payload.user.email]: [
              ...state.favoriteFilms[action.payload.user.email],
              action.payload.favoriteFilm
            ]
          }
        };
      } else {
        return {
          ...state
        };
      }
    }
    case "setExpectedFilm": {
      const expectedFilmsHasCurrentUser =
        state.expectedFilms[action.payload.user.email];
      const filmOnList = state.expectedFilms[action.payload.user.email]?.some(
        (film) => film.id === action.payload.expectedFilm.id
      );

      if (!filmOnList) {
        if (!expectedFilmsHasCurrentUser) {
          state.expectedFilms[action.payload.user.email] = [];
        }
        return {
          ...state,
          expectedFilms: {
            ...state.expectedFilms,
            [action.payload.user.email]: [
              ...state.expectedFilms[action.payload.user.email],
              action.payload.expectedFilm
            ]
          }
        };
      } else {
        return {
          ...state
        };
      }
    }
    default:
      return state;
  }
};
